class QuantityObserver {
  constructor() {
    this.init();
  }

  init() {
    this.processExistingSelectors();
    this.setupMutationObserver();
  }

  processExistingSelectors() {
    const selectors = document.querySelectorAll('quantity-selector-component');
    selectors.forEach((selector) => this.setupQuantitySelector(selector));
  }

  setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.matches && node.matches('quantity-selector-component')) {
                this.setupQuantitySelector(node);
              }

              const selectors = node.querySelectorAll && node.querySelectorAll('quantity-selector-component');
              if (selectors && selectors.length > 0) {
                selectors.forEach((selector) => this.setupQuantitySelector(selector));
              }
            }
          });
        }

        if (
          mutation.type === 'attributes' &&
          mutation.target.matches('input[name="quantity"]') &&
          mutation.attributeName === 'value'
        ) {
          this.updateMinusButtonState(mutation.target);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value'],
    });
  }

  setupQuantitySelector(selector) {
    const input = selector.querySelector('input[name="quantity"]');
    const minusButton = selector.querySelector('.quantity-minus');
    const plusButton = selector.querySelector('.quantity-plus');

    if (!input || !minusButton) return;

    input.dataset.lastValue = input.value || '1';

    this.updateMinusButtonState(input);

    input.addEventListener('input', () => {
      this.checkValueChange(input);
      this.updateMinusButtonState(input);
    });

    input.addEventListener('change', () => {
      this.checkValueChange(input);
      this.updateMinusButtonState(input);
    });

    minusButton.addEventListener('click', () => {
      this.handleButtonClick(input);
    });

    if (plusButton) {
      plusButton.addEventListener('click', () => {
        this.handleButtonClick(input);
      });
    }

    selector.addEventListener('click', (e) => {
      if (
        e.target.tagName === 'BUTTON' ||
        e.target.classList.contains('quantity-plus') ||
        e.target.classList.contains('quantity-minus') ||
        e.target.closest('button') ||
        e.target.closest('.quantity-plus') ||
        e.target.closest('.quantity-minus')
      ) {
        this.handleButtonClick(input);
      }
    });

    const inputObserver = new MutationObserver(() => {
      this.checkValueChange(input);
      this.updateMinusButtonState(input);
    });

    inputObserver.observe(input, {
      attributes: true,
      attributeFilter: ['value'],
    });
  }

  handleButtonClick(input) {
    this.checkValueChange(input);
    this.updateMinusButtonState(input);

    setTimeout(() => {
      this.checkValueChange(input);
      this.updateMinusButtonState(input);
    }, 50);

    setTimeout(() => {
      this.checkValueChange(input);
      this.updateMinusButtonState(input);
    }, 50);
  }

  checkValueChange(input) {
    const currentValue = parseInt(input.value) || 0;
    const lastValue = parseInt(input.dataset.lastValue) || 1;

    if (currentValue > 1 && lastValue !== currentValue) {
      this.resetMinusButtonStyling(input);
    }

    input.dataset.lastValue = currentValue.toString();
  }

  resetMinusButtonStyling(input) {
    const selector = input.closest('quantity-selector-component');
    if (!selector) return;

    const minusButton = selector.querySelector('.quantity-minus');
    if (!minusButton) return;

    minusButton.style.opacity = '1';
    minusButton.style.pointerEvents = 'auto';
    minusButton.removeAttribute('disabled');
  }

  updateMinusButtonState(input) {
    const selector = input.closest('quantity-selector-component');
    if (!selector) return;

    const minusButton = selector.querySelector('.quantity-minus');
    if (!minusButton) return;

    const currentValue = parseInt(input.value) || 0;
    const minValue = parseInt(input.getAttribute('min')) || 1;

    if (currentValue <= minValue) {
      minusButton.style.opacity = '0.5';
      minusButton.style.pointerEvents = 'none';
      minusButton.setAttribute('disabled', 'true');
    } else {
      minusButton.style.opacity = '1';
      minusButton.style.pointerEvents = 'auto';
      minusButton.removeAttribute('disabled');
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.quantityObserver = new QuantityObserver();
  });
} else {
  window.quantityObserver = new QuantityObserver();
}
